import { useMemo } from 'react';
import {
    CustomerUpdatesType,
    ICustomerNotificationActionContext,
} from '../../../../store/features/customerUpdates/customerUpdates.types';

export const useCustomerUpdatesDialogResultCallbacks = (
    updatesType: CustomerUpdatesType,
    customerId: number | undefined,
    callback?: (context: ICustomerNotificationActionContext) => void
) => {
    return useMemo(() => {
        if (!customerId || !callback) {
            return { onNotified: () => {}, onUnableToNotify: (reason) => {} };
        }

        const data = {
            customerId,
            updatesType,
        };

        return {
            onNotified: () =>
                callback({
                    action: 'Notified',
                    reason: null,
                    ...data,
                }),
            onUnableToNotify: (reason: string | null | undefined) =>
                callback({
                    action: 'UnableToNotify',
                    reason: reason ?? null,
                    ...data,
                }),
        };
    }, [updatesType, customerId, callback]);
};
